<template>
  <img class="hand" :class="{ 'hand--right': right }" src="@/assets/hand.png">
</template>

<script>
export default {
  props: ['right']
}
</script>

<style lang="scss" scoped>
@keyframes hand {
  0% {
    transform: translate(0, 0);
  }
  40% {
    transform: translate(-4%, -10%);
  }
  100% {
    transform: translate(0, 0);
  }
}
@keyframes hand-right {
  0% {
    transform: scale(-1, 1) translate(0, 0);
  }
  40% {
    transform: scale(-1, 1) translate(-4%, -10%);
  }
  100% {
    transform: scale(-1, 1) translate(0, 0);
  }
}
.hand {
  position: absolute;
  width: 35px !important;
  height: 37px !important;
  max-width: none;
  animation: 2s hand infinite;

  &--right {
    transform: scale(-1, 1);
    animation: 2s hand-right infinite;
  }
}
</style>
